import { createSlice } from '@reduxjs/toolkit'
import {
  getNotificationsListWithQueries,
  notificationCenterResetAlertHandler,
  filterNotificationsCenterList,
  getNotificationsCenterBell,
} from './notificationCenterThunk'
import { objNotEmpty, updateStateFromQueries } from '../../../../utils/helpers'

const defaultPageSize = 9
const defaultActiveSummary = 'ALL'

const initialState = {
  loading: {
    fetch: false,
    mutate: false,
  },
  alert: {},
  pageNumber: 0,
  summaries: {},
  sortBy: [],
  activeSort: {},
  filterList: [],
  activeFilters: {
    headers: [],
    date: [],
  },
  pageSize: defaultPageSize,
  activeSummary: defaultActiveSummary,
  activeSearch: '',
  data: [],
  lookups: {},
  updatedItem: {},
  finalPage: true,
  notificationsBell: {},
}

const notificationCenterSlice = createSlice({
  name: 'notificationCenter',
  initialState,

  extraReducers: (builder) => {
    builder.addCase(notificationCenterResetAlertHandler.fulfilled, (state) => {
      state.alert = {}
    });

    builder.addCase(
      getNotificationsListWithQueries.pending,
      (state, { meta: { arg: { queries } } }) => {
        state.loading.fetch = true
        state.alert = {}
        state.pageNumber = queries?.pageNumber ? queries?.pageNumber : 0
        if (!queries?.pageNumber) {
          state.data = []
        }
      },
    );

    builder.addCase(getNotificationsListWithQueries.rejected, (state, { payload }) => {
      state.loading.fetch = false
      state.alert = payload
    });

    builder.addCase(getNotificationsListWithQueries.fulfilled, (state, { payload }) => {
      const { response, queries } = payload

      state.data = queries?.pageNumber === 0 ? response?.data : [...state.data, ...response.data]
      state.sortBy = response?.sort
      state.filterList = response?.facets
      state.finalPage = response?.data?.length < state.pageSize
      state.pageNumber = 0
      state.loading.fetch = false
      state.alert = {}
      state.summaries = response.metadata
      updateStateFromQueries(state, queries)
      state.activeSort = objNotEmpty(state.activeSort) ? state.activeSort : response?.sort?.[0]
    });

    builder.addCase(getNotificationsCenterBell.pending, (state) => {
      state.loading.fetch = true
      state.notificationsBell = {}
      state.alert = {}
    });

    builder.addCase(getNotificationsCenterBell.rejected, (state, { payload }) => {
      state.loading.fetch = false
      state.alert = payload
    });

    builder.addCase(getNotificationsCenterBell.fulfilled, (state, { payload }) => {
      state.notificationsBell = payload
      state.loading.fetch = false
    });

    builder.addCase(filterNotificationsCenterList.pending, (state) => {
      state.loading.fetch = true
      state.alert = {}
      state.data = []
      state.pageNumber = 0
    })

    builder.addCase(filterNotificationsCenterList.rejected, (state, { payload }) => {
      state.loading.fetch = false
      state.alert = payload
    })

    builder.addCase(filterNotificationsCenterList.fulfilled, (state, { payload }) => {
      state.activeFilters = payload.filters
      state.data = payload.response.data
      state.sortBy = payload.response.sort
      state.filterList = payload.response.facets
      state.finalPage = payload.response.data?.length < state.pageSize
      state.pageNumber = 0
      state.loading.mutate = false
      state.alert = {}
      state.summaries = payload.response.metadata
      state.loading.fetch = false
    })
  },
})

export const selectNotification = ({ notificationCenter }) => notificationCenter

export default notificationCenterSlice.reducer
